module.exports = "<div class=value-reference> <value-object :fragment.sync=actualFragment :ref.sync=model></value-object> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueReference.vue
 ** module id = 148
 ** module chunks = 0
 **/